import React from "react";
import { useSelector } from "react-redux";
import ArticleCard from "./ArticleCard";
export default function Activiti() {
  const posts = useSelector((state) =>
    state.posts?.posts
      ?.filter(
        (post) =>
          (post.status === "published" &&
            post.slug !== "gioi-thieu" &&
            post.slug !== "dieu-khoan" &&
            post.category?.name === "Hoạt động đào tạo") ||
          [
            "Hội sinh viên",
            "An sinh người cao tuổi",
            "Cà phê doanh nhân",
          ].includes(post.category?.name)
      )
      ?.filter((e) => e.type !== "notification")
  );
  return (
    <div className="container mx-auto pt-2">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {posts?.slice(0, 6)?.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
